/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { API_PATH } from "src/environments/config";
import { FormArray, FormGroup } from "@angular/forms";
import { UserService } from "valuchaincommon/common-services/user/user.service";
import { SlotService } from "../../slot/slot.service";
import { BehaviorSubject } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class BusinessUsersApiService {
  initialOnboarding = new BehaviorSubject([]);
  public userGroups;
  public unitsCallCount = 0;
  public usersCallCount = 0;
  public branchesCallCount = 0;
  public brancUnitCallCount = 0;
  public userCreationCount = 0;
  employeesFiltered;
  users;
  constructor(
    public http: HttpClient,
    public valuChainUserService: UserService,
    public slotService: SlotService
  ) {}
  groupActionBusinessUser(data) {
    return this.http.post<any>(API_PATH.apis.businessUsersGroupAction, data);
  }
  getBusinessUsersByPage(data?) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("nosummary", "true");
    if (data) {
      httpParams = data.page ? httpParams.set("page", data.page) : httpParams;
      httpParams = data.limit
        ? httpParams.set("limit", data.limit)
        : httpParams;
      return this.http.get<any>(API_PATH.apis.businessUsers, {
        params: httpParams,
      });
    } else {
      return this.http.get<any>(API_PATH.apis.businessUsers, {
        params: httpParams,
      });
    }
  }
  getBusinessUnitUsers(id, page = 1, limit = 10) {
    let httpParams = new HttpParams();
    httpParams = page ? httpParams.set("page", page.toString()) : httpParams;
    httpParams = limit ? httpParams.set("limit", limit.toString()) : httpParams;
    return this.http.get<any>(API_PATH.apis.businessUnitDetails + id, {
      params: httpParams,
    });
  }
  getUserGroups() {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("isShopConnect", "true");
    return this.http.get<any>(API_PATH.apis.userGroups, { params: httpParams });
  }

  addBusUsers(data, value = false) {
    // data.userName=data.mail;
    data.bunits = value
      ? this.slotService.currentBusinessUnit
      : [this.valuChainUserService.currentBusinessUnitDetailBS.getValue()._id];
    data.company = JSON.parse(localStorage.getItem("company"))._id;
    data.isWhiteShopRetailerUser = true;
    return this.http.post<any>(API_PATH.apis.adduser, data);
  }

  updateUsers(data) {
    return this.http.put<any>(API_PATH.apis.updateuser, data);
  }

  valueChangesProfileImage(data, uploadFile) {
    uploadFile.formData = new FormData();
    uploadFile.formData = data;
    return uploadFile;
  }
}
